import { css, cx } from 'emotion';
import {
	tabletPortraitMaxWidthBreakpoint,
	mobileMaxWidthBreakpoint,
} from 'inside-out/global-styles';

import ViewAllIcon from './view-all-icon.svg';

export const innerStyle = css({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	justifyContent: 'flex-start',
	alignItems: 'stretch' /* Adjacent cards in row fill height */,
	alignContent: 'flex-start' /* Fill vertical space equally (2 rows would be 50% each)*/,
});

export const arrowToStyle = (top) => css({
	[`@media (min-width: ${tabletPortraitMaxWidthBreakpoint + 1}px)`]: {
		background: `transparent url(${ViewAllIcon}) no-repeat center center`,
		width: '76px',
		height: '74px',
		display: 'block',
		position: 'absolute',
		top: top,
		right: '0',
		transform: 'translate(21px, -50%)',
		content: '" "',
		zIndex: '1',
	},
});

export const wrapperStyle = (columns, scrollable, columnsAt) => {
	const base = {
		margin: '0 -12px',
		position: 'relative',

		[`& .${innerStyle}`]: cx(
			innerStyle,
			css({
				'& > [data-component=Card]': {
					width: `calc((100% / ${columns}) - 24px)`,
					display: 'block',
					margin: '12px',
					boxSizing: 'border-box',
				},
				...(columnsAt
					? Object.assign(
							...Object.keys(columnsAt)
								.sort((a, b) => {
									if (a.indexOf('max') !== -1) {
										return columnsAt[b] - columnsAt[a];
									} else {
										return columnsAt[a] - columnsAt[b];
									}
								})
								.map(c => {
									return {
										[`@media (${c}px)`]: {
											'& > [data-component=Card]': {
												width: `calc((100% / ${columnsAt[c]}) - 24px)`,
											},
										},
									};
								})
					  )
					: null),
			})
		),
	};

	if (scrollable) {
		return css({
			[`@media (min-width: ${tabletPortraitMaxWidthBreakpoint + 1}px)`]: base,

			[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
				...base,
				overflow: 'auto',
				margin: '0 -10px',

				[`& .${innerStyle}`]: {
					...base[`& .${innerStyle}`],
					minWidth: 'min-content',
					flexWrap: 'nowrap',
					'& > [data-component=Card]': {
						...base[`& .${innerStyle}`]['& > [data-component=Card]'],
						margin: '0 10px',
						width: '400px',
						[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
							width: '200px',
						},
					},
				},
			},
		});
	} else {
		return css({
			[`@media (min-width: ${tabletPortraitMaxWidthBreakpoint + 1}px)`]: base,

			[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
				...base,
				'& > div > [data-component=Card]:first-child': {
					marginTop: '0',
				},
				'& > div > [data-component=Card]:last-child': {
					marginBottom: '0',
				},
			},
		});
	}
};



// WEBPACK FOOTER //
// ./src/components/shared/cards/styles.js